'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sentry = require('./sentry');

Object.defineProperty(exports, 'initMonitoring', {
  enumerable: true,
  get: function get() {
    return _sentry.initMonitoring;
  }
});
Object.defineProperty(exports, 'captureException', {
  enumerable: true,
  get: function get() {
    return _sentry.captureException;
  }
});
Object.defineProperty(exports, 'createMonitoringMiddleware', {
  enumerable: true,
  get: function get() {
    return _sentry.createMonitoringMiddleware;
  }
});
Object.defineProperty(exports, 'captureEvent', {
  enumerable: true,
  get: function get() {
    return _sentry.captureEvent;
  }
});
Object.defineProperty(exports, 'setUser', {
  enumerable: true,
  get: function get() {
    return _sentry.setUser;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJpbml0TW9uaXRvcmluZyIsImNhcHR1cmVFeGNlcHRpb24iLCJjcmVhdGVNb25pdG9yaW5nTWlkZGxld2FyZSIsImNhcHR1cmVFdmVudCIsInNldFVzZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O21CQUNFQSxjOzs7Ozs7bUJBQ0FDLGdCOzs7Ozs7bUJBQ0FDLDBCOzs7Ozs7bUJBQ0FDLFk7Ozs7OzttQkFDQUMsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7XG4gIGluaXRNb25pdG9yaW5nLFxuICBjYXB0dXJlRXhjZXB0aW9uLFxuICBjcmVhdGVNb25pdG9yaW5nTWlkZGxld2FyZSxcbiAgY2FwdHVyZUV2ZW50LFxuICBzZXRVc2VyLFxufSBmcm9tICcuL3NlbnRyeSdcbiJdfQ==